import { Controller } from "@hotwired/stimulus";

// Toggles the mobile navigation drawer.
export default class extends Controller {
  static targets = ["menu", "openIcon", "closeIcon"];

  toggle() {
    this.menuTarget.classList.toggle("hidden");
    this.openIconTarget.classList.toggle("hidden");
    this.closeIconTarget.classList.toggle("hidden");
  }

  close() {
    this.menuTarget.classList.add("hidden");
    this.openIconTarget.classList.remove("hidden");
    this.closeIconTarget.classList.add("hidden");
  }
}
